/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2025-04-08 15:15:52
 * @FilePath: \crane-safety-manager\src\slices\auth\login\reducer.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createSlice } from '@reduxjs/toolkit';

import { getLoggedInUser } from '../../../helpers/auth_helper';

export const initialState = {
    user: getLoggedInUser() || {},
    error: '', // for error message
    loading: false,
    isUserLogout: false,
    errorMsg: false // for error
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        apiError(state, action) {
            state.error = action.payload;
            state.loading = true;
            state.isUserLogout = false;
            state.errorMsg = true;
        },
        loginSuccess(state, action) {
            state.user = action.payload;
            state.loading = false;
            state.errorMsg = false;
        },
        logoutUserSuccess(state, action) {
            state.isUserLogout = true;
        },
        reset_login_flag(state) {
            state.error = '';
            state.loading = false;
            state.errorMsg = false;
        }
    }
});

export const { apiError, loginSuccess, logoutUserSuccess, reset_login_flag } = loginSlice.actions;

export default loginSlice.reducer;
